<template>
  <section class="page-section">
    <span v-if="label" class="label">{{ label }}</span>
    <h2 v-if="typeof heading === 'string'" class="page-section__heading">{{ heading }}</h2>
    <h2
      v-else-if="Array.isArray(heading) && heading.length"
      class="page-section__heading"
    >
      <span
        v-for="line in heading"
        :key="line"
        class="page-section__heading-line"
      >
        {{ line }}
      </span>
    </h2>
    <p v-if="lede" class="page-section__lede">{{ lede }}</p>
    <slot />
  </section>
</template>

<script setup>
defineProps({
  label: String,
  heading: {
    type: [String, Array],
    default: '',
  },
  lede: String,
})
</script>
